<template>
  <div class="page-index">
    <!-- PC -->
    <swiper class="swiper pc-class" :options="swiperOption" ref="swiper">
      <swiper-slide class="swiper-slide-first">
        <div class="content-first">
          <div class="content"></div>
          <div class="photo">
            <div class="left"></div>
            <div class="center"></div>
            <div class="right"></div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide-second">
        <div class="content-first">
          <div class="content"></div>
          <div class="photo"></div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide-three">
        <div class="content-first">
          <div class="left">
            <div class="title-photo"></div>
            <div class="title-content">玩法一</div>
          </div>
          <div class="right">
            <div class="content">
              <p>集齐3份同角色卡牌<br/>可消耗合成一张「汤姆猫飞车珍藏版-该角色」动态卡牌</p>
            </div>
            <div class="photo">
              <div class="left"></div>
              <div class="center"></div>
              <div class="right"></div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide-four">
        <div class="content-first">
          <div class="left">
            <div class="title-photo"></div>
            <div class="title-content">玩法二</div>
          </div>
          <div class="right">
            <div class="content">
              <p>集齐4份任意不同角色卡牌</p>
              <p>可消耗合成一张「汤姆猫飞车典藏版-随机角色」动态卡牌</p>
              <p>（共 6 款，合成角色随机）</p>
            </div>
            <div class="photo">
              <div class="left"></div>
              <div class="center"></div>
              <div class="right"></div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide-five">
        <div class="content-first">
          <div class="left">
            <div class="title-photo"></div>
            <div class="title-content">玩法三</div>
          </div>
          <div class="right">
            <div class="content">
              <p>集齐6份全部角色卡牌</p>
              <p>可消耗合成一张「汤姆猫飞车典藏版」动态卡牌</p>
              <p>（共三款，合成海报随机）</p>
            </div>
            <div class="photo">
              <div class="left"></div>
              <div class="center"></div>
              <div class="right"></div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide-six">
        <div class="content-first">
          <div class="left">
            <div class="title-photo"></div>
            <div class="title-content">玩法四</div>
          </div>
          <div class="right">
            <div class="content">
              <p>集齐6份全部「汤姆猫飞车典藏版-随机角色」卡牌<br/>可消耗合成一张「汤姆猫飞车限量版-终极狂飙」动态卡牌+神秘实体周边</p>
            </div>
            <div class="photo">
              <div class="left"></div>
              <div class="center"></div>
              <div class="right"></div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <!-- phone -->
    <div class="container phone-class">
      <div class="content-first"></div>
      <div class="content-second">
        <div class="content">
          <p>以盲盒形式发售</p>
          <p>「会说话的汤姆猫家族飞车」主题系列卡牌</p>
          <p>共计6款《隐藏款+常规款》</p>
        </div>
        <div class="photo">
          <ul>
            <li>
              <div class="first"></div>
              <div class="second"></div>
            </li>
            <li>
              <div class="three"></div>
              <div class="four"></div>
            </li>
            <li>
              <div class="five"></div>
              <div class="six"></div>
            </li>
          </ul>
        </div>
      </div>
      <div class="content-third">
        <div class="play-one-title">
          <div class="photo"></div>
          <div class="title">玩法一</div>
        </div>
        <div class="play-one-content">
          <div class="title">
            <p>集齐3份同角色卡牌</p>
            <p>可消耗合成一张「汤姆猫飞车珍藏版-该角色」动态卡牌</p>
          </div>
          <div class="photo">
            <div class="photo-one"></div>
            <div class="photo-two"></div>
            <div class="photo-three"></div>
          </div>
        </div>
      </div>
      <div class="content-fourth">
        <div class="play-one-title">
          <div class="photo"></div>
          <div class="title">玩法二</div>
        </div>
        <div class="play-one-content">
          <div class="title">
            <p>集齐4份任意不同角色卡牌</p>
            <p>可消耗合成一张「汤姆猫飞车典藏版-随机角色」动态卡牌</p>
            <p>（共 6 款，合成角色随机）</p>
          </div>
          <div class="photo">
            <div class="photo-one"></div>
            <div class="photo-two"></div>
            <div class="photo-three"></div>
          </div>
        </div>
      </div>
      <div class="content-fifth">
        <div class="play-one-title">
          <div class="photo"></div>
          <div class="title">玩法三</div>
        </div>
        <div class="play-one-content">
          <div class="title">
            <p>集齐6份全部角色卡牌</p>
            <p>可消耗合成一张「汤姆猫飞车典藏版」动态卡牌</p>
            <p>（共三款，合成海报随机）</p>
          </div>
          <div class="photo">
            <div class="photo-one"></div>
            <div class="photo-two"></div>
            <div class="photo-three"></div>
          </div>
        </div>
      </div>
      <div class="content-sixth">
        <div class="play-one-title">
          <div class="photo"></div>
          <div class="title">玩法四</div>
        </div>
        <div class="play-one-content">
          <div class="title">
            <p>集齐6份全部「汤姆猫飞车典藏版-随机角色」卡牌</p>
            <p>可消耗合成一张「汤姆猫飞车限量版-终极狂飙」动态卡牌+神秘实体周边</p>
          </div>
          <div class="photo">
            <div class="photo-one"></div>
            <div class="photo-two"></div>
            <div class="photo-three"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@/assets/css/base.scss";
import "@/assets/css/rem/index.scss";
import "@/assets/css/rem/indexAdapter.scss";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        mousewheelControl: true,
        direction: "vertical",
        observer: true,
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.swiper {
  background-color: #2b3358;
  background-size: cover;
  height: 100vh;
  .swiper-slide-first {
    height: 100vh;
    position: relative;
    background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/first-bg.jpg') no-repeat center center;
    background-size: cover;
    .content-first {
      height: 100vh;
      display: flex;
      flex-direction: column;
      .content {
        width: 533px;
        height: 154px;
        background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/first-content.png') no-repeat center center;
        background-size: contain;
        position: absolute;
        top: 168px;
        left: 299px;
      }
      .photo {
        width: 100%;
        display: flex;
        position:absolute;
        top: 392px;
        padding: 20px;
        .left {
          width: 690px;
          height: 484px;
          background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/first-left.png') no-repeat center center;
          background-size: cover;
          position:absolute;
          left: 0;
          z-index: 1;
        }
        .center {
          width: 905px;
          height: 492px;
          background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/first-center.png') no-repeat center center;
          background-size: cover;
          position:absolute;
          left: 50%;
          transform: translate(-50%, 0);
          z-index: 2;
        }
        .right {
          width: 708px;
          height: 484px;
          background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/first-right.png') no-repeat center center;
          background-size: cover;
          position:absolute;
          right: 10px;
          z-index: 1;
        }
      }
    }
  }
  .swiper-slide-second {
    height: 100vh;
    position: relative;
    .content-first {
      display: flex;
      flex-direction: column;
      .content {
        width: 815px;
        height: 260px;
        background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/second-content.png') no-repeat center center;
        background-size: cover;
        position: absolute;
        top: 167px;
        left: 50%;
        transform: translate(-50%, 0);
      }
      .photo {
        width: 1440px;
        height: 292px;
        background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/second-photo.png') no-repeat center center;
        background-size: cover;
        position: absolute;
        top: 491px;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }

   
  }
  .swiper-slide-three {
    height: 100vh;
    position: relative;
    .content-first {
      width: 1251px;
      height: 746px;
      background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/container-one.png') no-repeat center center;
      background-size: cover;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .left {
        display: flex;
        position: absolute;
        top: 46px;
        left: 73px;
        .title-photo {
          width: 43px;
          height: 48px;
          background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-title.png') no-repeat center center;
          background-size: cover;
          
        }
        .title-content {
          font-size: 28px;
          font-weight: bold;
          color: #2B3358;
          line-height: 46px;
          margin-left: 22px;
        }
      }
      .right {
        .content {
          width: 814px;
          height: 135px;
          background: rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          position:absolute;
          top: 59px;
          right: 69px;
          text-align: center;
          p {
            font-size: 30px;
            font-weight: 800;
            color: #FFFFFF;
            line-height: 49px;
            margin-top: 15px;
          }
        }
        .photo {
          display: flex;
          .left {
            width: 352px;
            height: 290px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-left.png') no-repeat center center;
            background-size: cover;
            position: absolute;
            top: 293px;
            left: 373px;
          }
          .center {
            width: 88px;
            height: 92px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-center.png') no-repeat center center;
            background-size: cover;
            position: absolute;
            top: 412px;
            left: 775px;
          }
          .right {
            width: 268px;
            height: 492px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-right.png') no-repeat center center;
            background-size: cover;
            position:absolute;
            top: 230px;
            right: 84px;
          }
        }
      }
    }
  }
  .swiper-slide-four {
    height: 100vh;
    position: relative;
    .content-first {
      width: 1251px;
      height: 746px;
      background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/container-two.png') no-repeat center center;
      background-size: cover;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .left {
        display: flex;
        position: absolute;
        top: 156px;
        left: 73px;
        .title-photo {
          width: 43px;
          height: 48px;
          background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-title.png') no-repeat center center;
          background-size: cover;
          
        }
        .title-content {
          font-size: 28px;
          font-weight: bold;
          color: #2B3358;
          line-height: 46px;
          margin-left: 22px;
        }
      }
      .right {
        .content {
          width: 814px;
          height: 161px;
          background: rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          position:absolute;
          top: 59px;
          right: 69px;
          text-align: center;
          display: flex;
          flex-direction: column;
          p {
            font-size: 30px;
            font-weight: 800;
            color: #FFFFFF;
            line-height: 49px;
            margin-top: 5px;
          }
          p:nth-child(3) {
            font-size: 22px;
            font-weight: normal;
          }
        }
        .photo {
          display: flex;
          .left {
            width: 356px;
            height: 329px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/four-photo-left.png') no-repeat center center;
            background-size: cover;
            position: absolute;
            top: 296px;
            left: 343px;
          }
          .center {
            width: 88px;
            height: 92px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-center.png') no-repeat center center;
            background-size: cover;
            position: absolute;
            top: 414px;
            left: 724px;
          }
          .right {
            width: 561px;
            height: 414px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/four-photo-right.png') no-repeat center center;
            background-size: cover;
            position:absolute;
            top: 282px;
            right: -91px;
          }
        }
      }
    }
    
  }
  .swiper-slide-five {
    height: 100vh;
    position: relative;
    .content-first {
      width: 1251px;
      height: 746px;
      background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/container-three.png') no-repeat center center;
      background-size: cover;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .left {
        display: flex;
        position: absolute;
        top: 266px;
        left: 73px;
        .title-photo {
          width: 43px;
          height: 48px;
          background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-title.png') no-repeat center center;
          background-size: cover;
          
        }
        .title-content {
          font-size: 28px;
          font-weight: bold;
          color: #2B3358;
          line-height: 46px;
          margin-left: 22px;
        }
      }
      .right {
        .content {
          width: 814px;
          height: 160px;
          background: rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          position:absolute;
          top: 59px;
          right: 69px;
          text-align: center;
          p {
            font-size: 30px;
            font-weight: 800;
            color: #FFFFFF;
            line-height: 49px;
            margin-top: 5px;
          }
          p:nth-child(3) {
            font-size: 22px;
            font-weight: normal;
          }
        }
        .photo {
          display: flex;
          .left {
            width: 391px;
            height: 219px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/five-photo-left.png') no-repeat center center;
            background-size: cover;
            position: absolute;
            top: 349px;
            left: 351px;
          }
          .center {
            width: 88px;
            height: 92px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-center.png') no-repeat center center;
            background-size: cover;
            position: absolute;
            top: 412px;
            left: 780px;
          }
          .right {
            width: 533px;
            height: 531px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/five-photo-right.png') no-repeat center center;
            background-size: cover;
            position:absolute;
            top: 227px;
            right: -57px;
          }
        }
      }
    }
    
  }
  .swiper-slide-six {
    height: 100vh;
    position: relative;
    .content-first {
      width: 1251px;
      height: 746px;
      background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/container-four.png') no-repeat center center;
      background-size: cover;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .left {
        display: flex;
        position: absolute;
        top: 376px;
        left: 73px;
        .title-photo {
          width: 43px;
          height: 48px;
          background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-title.png') no-repeat center center;
          background-size: cover;
          
        }
        .title-content {
          font-size: 28px;
          font-weight: bold;
          color: #2B3358;
          line-height: 46px;
          margin-left: 22px;
        }
      }
      .right {
        .content {
          width: 937px;
          height: 140px;
          background: rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          position:absolute;
          top: 53px;
          right: 30px;
          text-align: center;
          padding: 0px 15px;
          p {
            font-size: 28px;
            font-weight: 800;
            color: #FFFFFF;
            line-height: 49px;
            margin-top: 15px;
          }
        }
        .photo {
          display: flex;
          .left {
            width: 391px;
            height: 219px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/six-photo-left.png') no-repeat center center;
            background-size: cover;
            position: absolute;
            top: 344px;
            left: 351px;
          }
          .center {
            width: 88px;
            height: 92px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-center.png') no-repeat center center;
            background-size: cover;
            position: absolute;
            top: 405px;
            left: 775px;
          }
          .right {
            width: 482px;
            height: 525px;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/six-photo-right.png') no-repeat center center;
            background-size: cover;
            position:absolute;
            top: 211px;
            right: -48px;
          }
        }
      }
    }

    
  }
}
.pc-class {
  display: block;
}
.phone-class {
  display: none;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 560px) {
    .container {
      background-color: #2b3358;
      background-size: cover;
      padding-bottom: 15px;
      .content-first {
        height: 3rem;
        background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/first-bg.png') no-repeat center center;
        background-size: cover;
      }
      .content-second {
        .content {
          margin-top: 1.2rem;
          text-align: center;
          p {
            font-size: 18px;
            color: #FFFFFF;
            font-weight: 500;
            line-height: 0.69rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
          }
          p:nth-child(3) {
            background: linear-gradient(270deg, #63B3D8 0%, #585B7D 100%);
            -webkit-background-clip: text;
            color: transparent;
          }
        }
        .photo {
          margin-top: 1.34rem;
          display: flex;
          flex-direction: column;
          ul {
            li {
              display: flex;
              .first {
                  width: 233px;
                  height: 152px;
                  background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/second-photo-one.png') no-repeat center center;
                  background-size: cover;
                }
                .second {
                  width: 233px;
                  height: 152px;
                  background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/second-photo-two.png') no-repeat center center;
                  background-size: cover;
                }
                .three {
                  width: 233px;
                  height: 152px;
                  background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/second-photo-three.png') no-repeat center center;
                  background-size: cover;
                }
                .four {
                  width: 233px;
                  height: 152px;
                  background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/second-photo-four.png') no-repeat center center;
                  background-size: cover;
                }
                .five {
                  width: 233px;
                  height: 152px;
                  background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/second-photo-five.png') no-repeat center center;
                  background-size: cover;
                }
                .six {
                  width: 233px;
                  height: 152px;
                  background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/second-photo-six.png') no-repeat center center;
                  background-size: cover;
                }
            }
          }
        }
      }
      .content-third {
        margin-top: 0.84rem;
        .play-one-title {
          width: 90%;
          height: 1.15rem;
          background: #FFFFFF;
          box-shadow: 0px 4px 27px 0px rgba(0,0,0,0.5);
          border-radius: 0.19rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 auto;
          .photo {
            width: 0.4rem;
            height: 0.46rem;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-title.png') no-repeat center center;
            background-size: cover;
          }
          .title {
            font-size: 18px;
            font-weight: 400;
            color: #2B3358;
            line-height: 0.63rem;
            margin-left: 0.20rem;
          }
        }
        .play-one-content {
          width: 90%;
          height: 400px;
          background: rgba(163, 169, 201, 1);
          border-radius: 0.19rem;
          margin: 0.38rem auto;
          .title {
            font-size: 12px;
            color: #2B3358;
            line-height: 0.57rem;
            text-align: center;
            padding-top: 0.2rem;
          }
          .photo {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 0.7rem;
            padding: 0 0.1rem;
            .photo-one {
              width: 2.11rem;
              height: 1.73rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-left.png') no-repeat center center;
              background-size: cover;
            }
            .photo-two {
              width: 0.88rem;
              height: 0.92rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-center.png') no-repeat center center;
              background-size: cover;
            }
            .photo-three {
              width: 1.68rem;
              height: 4.92rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-right.png') no-repeat center center;
              background-size: cover;
            }
          }
        }
      }
      .content-fourth {
        margin-top: 0.84rem;
        .play-one-title {
          width: 90%;
          height: 1.15rem;
          background: #FFFFFF;
          box-shadow: 0px 4px 27px 0px rgba(0,0,0,0.5);
          border-radius: 0.19rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 auto;
          .photo {
            width: 0.4rem;
            height: 0.46rem;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-title.png') no-repeat center center;
            background-size: cover;
          }
          .title {
            font-size: 18px;
            font-weight: 400;
            color: #2B3358;
            line-height: 0.63rem;
            margin-left: 0.20rem;
          }
        }
        .play-one-content {
          width: 90%;
          height: 400px;
          background: rgba(163, 169, 201, 1);
          border-radius: 0.19rem;
          margin: 0.38rem auto;
          .title {
            font-size: 12px;
            color: #2B3358;
            line-height: 0.57rem;
            text-align: center;
            padding-top: 0.2rem;
          }
          .photo {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 1rem;
            padding: 0 0.1rem;
            transform: translateX(10px);
            .photo-one {
              width: 2.11rem;
              height: 1.93rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/four-photo-left.png') no-repeat center center;
              background-size: cover;
            }
            .photo-two {
              width: 0.88rem;
              height: 0.92rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-center.png') no-repeat center center;
              background-size: cover;
            }
            .photo-three {
              width: 3.21rem;
              height: 3.14rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/four-photo-right.png') no-repeat center center;
              background-size: cover;
            }
          }
        }
      }
      .content-fifth {
        margin-top: 0.84rem;
        .play-one-title {
          width: 90%;
          height: 1.15rem;
          background: #FFFFFF;
          box-shadow: 0px 4px 27px 0px rgba(0,0,0,0.5);
          border-radius: 0.19rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 auto;
          .photo {
            width: 0.4rem;
            height: 0.46rem;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-title.png') no-repeat center center;
            background-size: cover;
          }
          .title {
            font-size: 18px;
            font-weight: 400;
            color: #2B3358;
            line-height: 0.63rem;
            margin-left: 0.20rem;
          }
        }
        .play-one-content {
          width: 90%;
          height: 400px;
          background: rgba(163, 169, 201, 1);
          border-radius: 0.19rem;
          margin: 0.38rem auto;
          .title {
            font-size: 12px;
            color: #2B3358;
            line-height: 0.57rem;
            text-align: center;
            padding-top: 0.2rem;
          }
          .photo {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 1rem;
            padding: 0 0.1rem;
            transform: translateX(10px);
            .photo-one {
              width: 2.11rem;
              height: 1.93rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/five-photo-left.png') no-repeat center center;
              background-size: cover;
            }
            .photo-two {
              width: 0.88rem;
              height: 0.92rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-center.png') no-repeat center center;
              background-size: cover;
              transform: translateX(20px);
            }
            .photo-three {
              width: 3.21rem;
              height: 3.14rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/five-photo-right.png') no-repeat center center;
              background-size: cover;
              transform: translateX(10px);
            }
          }
        }
      }
      .content-sixth {
        margin-top: 0.84rem;
        .play-one-title {
          width: 90%;
          height: 1.15rem;
          background: #FFFFFF;
          box-shadow: 0px 4px 27px 0px rgba(0,0,0,0.5);
          border-radius: 0.19rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 auto;
          .photo {
            width: 0.4rem;
            height: 0.46rem;
            background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-title.png') no-repeat center center;
            background-size: cover;
          }
          .title {
            font-size: 18px;
            font-weight: 400;
            color: #2B3358;
            line-height: 0.63rem;
            margin-left: 0.20rem;
          }
        }
        .play-one-content {
          width: 90%;
          height: 400px;
          background: rgba(163, 169, 201, 1);
          border-radius: 0.19rem;
          margin: 0.38rem auto;
          .title {
            font-size: 12px;
            color: #2B3358;
            line-height: 0.57rem;
            text-align: center;
            padding-top: 0.2rem;
          }
          .photo {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 1rem;
            padding: 0 0.1rem;
            transform: translateX(10px);
            .photo-one {
              width: 2.11rem;
              height: 1.93rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/six-photo-left.png') no-repeat center center;
              background-size: cover;
            }
            .photo-two {
              width: 0.88rem;
              height: 0.92rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/three-photo-center.png') no-repeat center center;
              background-size: cover;
              transform: translateX(20px);
            }
            .photo-three {
              width: 3.21rem;
              height: 3.14rem;
              background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/six-photo-right.png') no-repeat center center;
              background-size: cover;
              transform: translateX(10px);
            }
          }
        }
      }
    }
    .pc-class {
      display: none;
    }
    .phone-class {
      display: block;
    }
}
</style>
